<template>
    <div :style="`max-height: calc(100vh - ${calculatedHeight}px)`" class="absolute top-full left-0 w-full bg-white border-t overflow-x-auto overflow-y-auto flex flex-col max-w-[100vw]">
        <div class="flex justify-between border-b py-3 px-4">
            <MiscLink
                to="/customer"
                tabindex="0"
                class="relative inline-flex flex-col items-center hover:cursor-pointer py-1 px-3 rounded-lg text-link hover:bg-base-200"
                @click="toggleFlyout('menu')"
            >
                <MiscIcon name="user" size="xl" />

                <span class="text-lg inline-block leading-6">
                    {{ t('layout.header.actions.account.label') }}
                </span>
            </MiscLink>

            <MiscLink
                to="/customer/wishlist"
                tabindex="0"
                class="relative flex-col items-center hover:cursor-pointer py-1 px-3 rounded-lg text-link hover:bg-base-200 inline-flex"
                @click="toggleFlyout('menu')"
            >
                <div class="indicator inline-flex flex-col items-center">
                    <MiscIcon name="wishlist" size="xl" />

                    <span class="text-lg inline-block leading-6">
                        {{ t('layout.header.actions.wishlist.label') }}
                    </span>

                    <client-only>
                        <span v-if="miniWishlist?.length > 0" class="badge badge-new badge-sm [--size:1.125rem] indicator-item top-3 right-8 text-base" v-text="miniWishlist?.length" />
                    </client-only>
                </div>
            </MiscLink>

            <MiscLink
                v-if="locale === 'de'"
                to="/abo-service"
                :target="null"
                class="relative inline-flex flex-col items-center hover:cursor-pointer py-1 px-3 rounded-lg text-link hover:bg-base-200"
            >
                <MiscIcon name="harvest-product" size="xl" />
                <span class="text-lg inline-block leading-6">
                    {{ t('layout.header.actions.abo.label') }}
                </span>
            </MiscLink>

            <MiscLink
                v-if="data?.serviceTitle?.value"
                :to="data?.serviceUrl?.value"
                :target="data?.serviceMenu1NewTab?.value ? '_blank' : null"
                class="relative inline-flex flex-col items-center hover:cursor-pointer py-1 px-3 rounded-lg text-link hover:bg-base-200"
            >
                <MiscIcon name="phone" size="xl" />
                <span class="text-lg inline-block leading-6">
                    {{ data?.serviceTitle?.value }}
                </span>
            </MiscLink>
        </div>

        <MenuMobile :data="data" :navigation="navigation" />
    </div>
</template>

<script setup lang="ts">
import type { HblNavigation } from "@/utils/types";
import {useFlyout, useWishlist, useSharedHeightMobileMenu} from '#imports'
import { storeToRefs } from "pinia";
import { useI18n } from 'vue-i18n'
import {computed} from "vue";

const { t, locale } = useI18n()

const { toggleFlyout } = useFlyout()

const props = defineProps<{
    navigation: HblNavigation | null
    label?: string
    data?: any
}>()

const wishlistStore = useWishlist()
const { miniWishlist } = storeToRefs(wishlistStore)
const { sharedHeight, isHeaderFixed } = storeToRefs(useSharedHeightMobileMenu())

const calculatedHeight = computed(() => {
    const headerHeight = 73
    const borderHeight = 1 // account for border-t on flyout
    // When header is absolute (at top of page), it's positioned below the promo bar in document flow
    // When header is fixed (scrolled), it's at top:0 and promo bar is scrolled away
    if (!isHeaderFixed.value) {
        return sharedHeight.value + headerHeight + borderHeight
    }
    return headerHeight + borderHeight
})
</script>
